import type { AppleTripSurfaceSnapshotV1 } from '@/services/applePlatformSnapshot';

/** Avoid clobbering a rich widget snapshot when a cache-only sync has no itinerary rows. */
export const mergeTripSurfaceSnapshot = (
  incoming: AppleTripSurfaceSnapshotV1,
  existing: AppleTripSurfaceSnapshotV1 | null,
): AppleTripSurfaceSnapshotV1 => {
  if (!existing?.trip?.tripId || existing.trip.tripId !== incoming.trip?.tripId) {
    return incoming;
  }

  const incomingAll = incoming.allItems ?? [];
  const existingAll = existing.allItems ?? [];
  const incomingToday = incoming.todayItems ?? [];
  const existingToday = existing.todayItems ?? [];

  if (incomingAll.length === 0 && existingAll.length > 0) {
    return {
      ...incoming,
      allItems: existingAll,
      todayItems: incomingToday.length > 0 ? incomingToday : existingToday,
      summary:
        incoming.summary?.nextItem || !existing.summary?.nextItem
          ? incoming.summary
          : {
              ...incoming.summary!,
              nextItem: incoming.summary?.nextItem ?? existing.summary.nextItem,
              currentItem: incoming.summary?.currentItem ?? existing.summary.currentItem,
              afterNextItem: incoming.summary?.afterNextItem ?? existing.summary.afterNextItem,
            },
    };
  }

  return incoming;
};
